<section [ngClass]="openedFromIndividualSchool || requestToCreate || createRole ? '' : 'main-section usercenter-section p-3'">
  <div>
    <label *ngIf="!userRole.includes(rolesMaster.MatAdmin)" class="text-blacka label-create-role font-bold mb-3">Create Audiences</label>
    <div class="bg-white justify-content-between align-items-center radius8 mb-2 p-4">
      <div class="content-box py-0" 
      [ngClass]="{
        'admin-user-center mb-0': userRole.includes(rolesMaster.MatAdmin),
        'createrole-contentbox' : !userRole.includes(rolesMaster.MatAdmin)
      }"[formGroup]="roleForm">
        <div *ngIf="!isEdit" class="text-end">
          <mat-icon matTooltip="Reset Form" (click)="clearRoleForm()" class="cursor-pointer">refresh</mat-icon>
        </div>
        <div *ngFor="let role of rolesArray.controls; let i = index">
          <ng-container [formGroup]="getFormGroup(role)">
            <div class="row mb-2">
              <div class="col-sm-6 mb-0">
                <label class="black-text option-create-role mb-1">Audience Type</label>
                <input type="text" [required]="true" formControlName="roleName" class="form-control bg-zircon w400"
                  [readOnly]="isEdit && getFormGroup(role).controls['roleId'].value > 0"
                  [class.is-invalid]="
                    getFormGroup(role).controls['roleName']
                      .invalid &&
                    getFormGroup(role).controls['roleName'].touched" />
                <div *ngIf="
                    (getFormGroup(role).controls['roleName']
                      .invalid &&
                      getFormGroup(role).controls['roleName']
                        .touched) ||
                    getFormGroup(role).controls['roleName'].dirty">
                  <small *ngIf="getFormGroup(role).controls['roleName'].errors?.['required']"
                    class="text-danger fs-13">Audience Type is required</small>
                  <small *ngIf="getFormGroup(role).controls['roleName'].errors?.['pattern']"
                    class="text-danger fs-13">Please provide a valid Audience Type</small>
                </div>
              </div>
              <div class="col-sm-6 mb-0 text-end m-auto" *ngIf="rolesArray?.controls?.length! > 1">
                <button type="button" class="btn link-delete link-delete-school border-red px-2 ms-3 option-create-role mt-2 mt-md-0"
                  (click)="onDeleteRole(i)">
                  <img class="me-2" src="../assets/images/delete-icon.svg" alt="" />
                  Delete Role
                </button>
              </div>
            </div>
            <div>
              <div class="col-sm-12">
                <div class="mb-2">
                  <div class="row">
                    <div class="col-md-3">
                      <span class="black-text option-create-role mb-1">Module</span>
                    </div>
                    <div class="col-md-9 justify-content-end d-flex">
                      <span class="option-create-role mb-0 text-dusty-gray mt2">Here is the list of modules for your selected package</span>
                      <div class="dropdown dropdown-actions view-list-dropdown ms-1 option-create-role">
                        <button
                          (click)="moduleSelect.open()"
                          class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          View Module List
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <mat-form-field>
                      <mat-select #moduleSelect required formControlName="modules" multiple (selectionChange)="onModuleChange($event, role)"
                      [class.is-invalid]="getFormGroup(role).controls['modules'].invalid && getFormGroup(role).controls['modules'].touched">
                        <mat-select-trigger>
                          <span class="chip-list-head">Added Items:</span>
                          <span class="chip-main">
                            <span *ngFor="let moduleValue of getFormGroup(role).controls['modules'].value" class="chip-list">{{moduleValue.moduleName}}
                              <a class="close" (click)="$event.stopPropagation();$event.preventDefault(); removeModule(moduleValue, role)">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </a>
                            </span>
                          </span>
                          @if ((getFormGroup(role).controls['modules'].value?.length || 0) > 0) {
                          <span class="chip-list count" (click)="$event.stopPropagation(); $event.preventDefault(); previewPopup('Added Modules','Module', role)">
                            #{{(getFormGroup(role).controls['modules'].value?.length)}}
                          </span>
                          }
                        </mat-select-trigger>
                        @for (module of package.modules; track module) {
                          <mat-option [value]="module">{{module.moduleName}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="(getFormGroup(role).controls['modules'].invalid && getFormGroup(role).controls['modules'].touched) || getFormGroup(role).controls['modules'].dirty">
                      <small *ngIf="getFormGroup(role).controls['modules'].errors?.['required']" class="text-danger fs-13">Module is required</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-md-3">
                    <span class="black-text option-create-role mb-1">Subcategory</span>
                  </div>
                  <div class="col-md-9 justify-content-end d-flex">
                    <span class="option-create-role mb-0 text-dusty-gray mt2">Here is the list of Analytics Toolkits for your selected package</span>
                    <div class="dropdown dropdown-actions view-list-dropdown ms-1 option-create-role">
                      <button
                        (click)="subcategorySelect.open()"
                        class="dropdown-toggle existing-package-btn btn theme-btn-underline w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        View Analytics Toolkit List
                      </button>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <mat-form-field>
                    <mat-select #subcategorySelect required formControlName="subCategories" multiple
                    (valueChange)="this.groupedSubCategories = this._createGroupedValues($event);"
                    [class.is-invalid]="getFormGroup(role).controls['subCategories'].invalid && getFormGroup(role).controls['subCategories'].touched">
                      <mat-select-trigger>
                        <span class="chip-list-head">Added Items:</span>
                        <span class="chip-main">
                          <span *ngFor="let moduleGroup of groupedSubCategories | keyvalue" >
                              <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{moduleGroup.key}}</h4>

                              <span *ngFor="let subCategoryValue of moduleGroup.value" 
                              style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                              class="chip-list toolkit-display" title="{{subCategoryValue.subCategoryName}}">
                                <label class="toolkit-display"  >
                                  <mat-icon style="font-size: 1.8em;" *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                                  <span class="toolkit-display-text" *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                                  <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                                </label>
                                <a class="close" (click)="$event.stopPropagation();$event.preventDefault();removeSubCategory(subCategoryValue, role)">
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                  </a>
                              </span>
                            </span>
                        </span>
                        @if ((getFormGroup(role).controls['subCategories'].value?.length || 0) > 0) {
                        <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Analytics Toolkits', 'SubCategory', role)">
                          #{{(getFormGroup(role).controls['subCategories'].value?.length)}}
                        </span>
                        }
                      </mat-select-trigger>
                      <mat-optgroup *ngFor="let rg of (this.availableGroupedSubCategories??{}) | keyvalue" [label]="rg.key">
                       @for (subCategory of rg.value; track subCategory) {
                      <mat-option 
                        [class.multiline]="subCategory.subCategoryDisplayName!=null" 
                        [value]="subCategory">
                          @if(subCategory.subCategoryDisplayName==null)
                          {
                            {{subCategory.subCategoryName}}
                          }
                          @else {
                            <label class="toolkit-display">
                              <mat-icon >short_text</mat-icon>
                              <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                              <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                            </label>
                          }
                        </mat-option>
                    }
                  </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="(getFormGroup(role).controls['subCategories'].invalid && getFormGroup(role).controls['subCategories'].touched) || getFormGroup(role).controls['subCategories'].dirty">
                    <small *ngIf="getFormGroup(role).controls['subCategories'].errors?.['required']" class="text-danger fs-13">Analytics Toolkit is required</small>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="!requestToCreate" class="col-sm-12 text-end">
          <div class="mt-0 mt-sm-0 pt-0 pt-sm-0">
            <button type="button" class="btn theme-btn-outline px-5 fw-bold"
              [disabled]="
              roleForm.invalid ||
              roleForm.untouched"
              (click)="addRoleDetail()">
              Add Another Role
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>